// src/lib/kinema/devtools/ExportPanel.tsx
import { useState } from 'react';
import { useEditor } from '../konva/hooks';

export function ExportPanel() {
  const editor = useEditor();
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const json = editor.toJSON();
    const text = JSON.stringify(json, null, 2);
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleLog = () => {
    const json = editor.toJSON();
    console.log('Editor state:', json);
  };

  return (
    <div style={{ padding: 12, fontSize: 12, color: '#334155', background: '#ffffff', height: '100%' }}>
      <div style={{ marginBottom: 12 }}>
        <button
          onClick={handleCopy}
          style={{
            background: copied ? '#16a34a' : '#2563eb',
            color: '#fff',
            border: 'none',
            borderRadius: 4,
            padding: '6px 16px',
            fontSize: 12,
            cursor: 'pointer',
            marginRight: 8,
          }}
        >
          {copied ? 'Copied!' : 'Copy JSON to Clipboard'}
        </button>
        <button
          onClick={handleLog}
          style={{
            background: '#f1f5f9',
            color: '#334155',
            border: '1px solid #e2e8f0',
            borderRadius: 4,
            padding: '6px 16px',
            fontSize: 12,
            cursor: 'pointer',
          }}
        >
          Log to Console
        </button>
      </div>

      <pre style={{
        background: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: 4,
        padding: 8,
        fontSize: 10,
        fontFamily: 'monospace',
        overflow: 'auto',
        maxHeight: 140,
        color: '#475569',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-all',
      }}>
        {JSON.stringify(editor.toJSON(), null, 2)}
      </pre>
    </div>
  );
}
